import { render, staticRenderFns } from "./FormCompanion.vue?vue&type=template&id=4347ced6"
import script from "./FormCompanion.vue?vue&type=script&lang=js"
export * from "./FormCompanion.vue?vue&type=script&lang=js"
import style0 from "./FormCompanion.vue?vue&type=style&index=0&id=4347ced6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports